angular.module("ticketco/common")
  .directive("tcZipCode", function tcZipCode() {
    return {
      require: "ngModel",
      link: function (scope, elem, attrs, ngModelCtrl) {
        ngModelCtrl.$validators.zip = function (modelValue, viewValue) {
          var number = modelValue || viewValue;
          if (number == null) {
            return true;
          }
          // TODO: Add real validation, when we will have requirements
          return true;
        };
      },
    };
  });
